<template>
  <div class="helper-tip" :class="{'active':active}" @click="toggle" v-show="rte.length">
    <div class="helper-tip__content" :style="contentStyle" ref="content">
      <div v-html="rte"></div>
    </div>
    <div class="helper-tip__button"></div>
  </div>   
</template>
<script>
export default {
  props: {
    rte: String
  },
  data: function() {
    return {
      active: false,
      contentHeight: '0px',
    }
  },
  computed: {
    contentStyle() {
      return {
        height: this.active ? this.contentHeight : '0px',
      };
    },
  },
  methods: {
    toggle() {
      this.active = !this.active;
      if (this.active) {
        this.$nextTick(() => {
          this.contentHeight = this.$refs.content.scrollHeight + 'px';
        });
      } else {
        this.contentHeight = '0px';
      }
    }
  }
};
</script>
<style scoped lang="postcss">
.helper-tip {
  font-family: var(--font-it-ex);
  font-weight: 400;
  margin-top: 10px;
  font-size: 14px;
  
  @media screen and (min-width: 768px) {
    max-width: 325px;
  }

  &__content {
    padding: 10px;
    border-radius: 16px;;
    background:#d4f7ec;
    min-height: 60px;
    overflow: hidden;
    position: relative;
    transition: all ease 0.5s;
    line-height:18px;
    &:after {
      transition: all ease 1s;
      content: "";
      display: block;
      width: 100%;
      height: 70%;
      position: absolute;
      bottom: 0;
      left: 0;
      background: linear-gradient(transparent, #d4f7ec 80%);      
    }
  }
  &__button {
    background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='50' cy='50' r='45' fill='%23001965' /%3E%3Crect x='45' y='20' width='10' height='60' fill='white' /%3E%3Crect x='20' y='45' width='60' height='10' fill='white' /%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    height:18px;
    width: 18px;
    margin: auto;
    position: relative;
    top: -9px;
    transition: all ease 0.3s;
  }

  &:hover {
    cursor: pointer;
    .helper-tip__button {
      transform: translateY(-2px);
    }

  }

  &.active {
    .helper-tip__content {      
      &:after {
        height:10px;         
      }
    }
    .helper-tip__button {
      background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='50' cy='50' r='45' fill='%23001965' /%3E%3Crect x='20' y='45' width='60' height='10' fill='white' /%3E%3C/svg%3E");
    }
  }
}
</style>